import { render, staticRenderFns } from "./LoginIdForgot.vue?vue&type=template&id=3a31c9fb&scoped=true"
import script from "./LoginIdForgot.vue?vue&type=script&lang=ts"
export * from "./LoginIdForgot.vue?vue&type=script&lang=ts"
import style0 from "./LoginIdForgot.vue?vue&type=style&index=0&id=3a31c9fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31c9fb",
  null
  
)

export default component.exports